module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_1.874e7efc.png";